<template>
    <div class="content">
        <div class="content_head">
            <div class="head_left">
                <div class="searchDate">
                    <!-- 日期搜索 -->
                    日期搜索:
                    <el-date-picker
                        v-model="searchDate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        >
                    </el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="SearchDate">搜索</el-button>
                </div>
                <div class="searchName">
                    <!-- 名字搜索 -->
                    姓名搜索:
                    <input type="text" v-model="searchName"/>
                     <el-button type="primary" icon="el-icon-search" @click="SearchName">搜索</el-button>
                    <!-- <el-input
                        placeholder="请输入姓名搜索"
                        v-model="searchName"
                        clearable>
                    </el-input> -->
                </div>
            </div>
            <div class="head_right">
                <div class="head_right_o center">
                    <span class="head_text">今日绝当：{{todayTotal}}</span>
                    <h4 style="color:#ffffff">金额：{{todayPri}}</h4>
                </div>
                <div class="head_right_t center">
                    <span class="head_text">{{title}}：{{Total}}</span>
                    <h4 style="color:#ffffff">金额：{{zPri}}</h4>
                </div>
            </div>
        </div>
        <div class="middle">
            <el-tabs type="border-card" @tab-click="tabClick">
                <el-tab-pane label="绝当待确认业务">
                    <el-table
                        :data="todayData.data"
                        height="750"
                        border
                        style="width: 100%">
                    <el-table-column
                        prop="dates"
                        label="操作日期"
                        width="180">
                        </el-table-column>
                    <el-table-column
                        prop="piaonum"
                        label="票号"
                        width="130">
                        </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="130">
                        </el-table-column>
                     <el-table-column
                        prop="tel"
                        label="电话"
                        width="120">
                        </el-table-column>
                    <el-table-column
                        prop="plateNumber"
                        label="车牌号"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="brand"
                        label="品牌"
                        width="160">
                        </el-table-column>
                    <el-table-column
                        prop="radio"
                        label="车辆状态"
                        width="150">
                        </el-table-column>
                    <el-table-column
                        prop="startDate"
                        label="开始日期"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="DateClosed"
                        label="到期日期"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="overallValuation"
                        label="车辆估值"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="sum"
                        label="典当金额"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="comprehensive"
                        label="典当综合费"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="lx"
                        label="典当利息"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="det"
                        label="典当天数"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="parkingFee"
                        label="停车费"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="agent"
                        label="经办人"
                        width="90">
                        </el-table-column>
                    <el-table-column
                        prop="reviewer"
                        label="复核"
                        width="90">
                        </el-table-column>
                        <el-table-column
                            fixed="left"
                            label="操作"
                            width="150">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                                <el-button @click="confirm(scope.row._id)" type="text" size="small">确定绝当</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="绝当业务">
                    <el-table
                        :data="tableData"
                        height="750"
                        border
                        style="width: 100%">
                    <el-table-column
                        prop="dates"
                        label="操作日期"
                        width="180">
                        </el-table-column>
                    <el-table-column
                        prop="piaonum"
                        label="票号"
                        width="130">
                        </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="130">
                        </el-table-column>
                     <el-table-column
                        prop="tel"
                        label="电话"
                        width="120">
                        </el-table-column>
                    <el-table-column
                        prop="plateNumber"
                        label="车牌号"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="brand"
                        label="品牌"
                        width="160">
                        </el-table-column>
                    <el-table-column
                        prop="radio"
                        label="车辆状态"
                        width="150">
                        </el-table-column>
                    <el-table-column
                        prop="startDate"
                        label="开始日期"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="DateClosed"
                        label="到期日期"
                        width="110">
                        </el-table-column>
                    <el-table-column
                        prop="overallValuation"
                        label="车辆估值"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="sum"
                        label="典当金额"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="comprehensive"
                        label="典当综合费"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="lx"
                        label="典当利息"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="det"
                        label="典当天数"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="parkingFee"
                        label="停车费"
                        width="100">
                        </el-table-column>
                    <el-table-column
                        prop="agent"
                        label="经办人"
                        width="90">
                        </el-table-column>
                    <el-table-column
                        prop="reviewer"
                        label="复核"
                        width="90">
                        </el-table-column>
                        <el-table-column
                            fixed="left"
                            label="操作"
                            width="150">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>

      
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
export default {
    name:"CarForbidden",
    inject:['reload'],
    data(){
        return{
            tableData:[],
            day:"",
            todayData:[], //绝当待确认的数据
            title:"绝当待确认",
            zPri:0,
            Total:0,
            todayTotal:0, //今天绝当的数量
            todayPri:0,  //今天绝当金额
            searchDate:"", //搜索筛选的日期
            searchName:"", //搜索名字
            tabIndex:"0",  //当前选中的tab
        }
    },
    methods:{
        sumPri(data){
            //计算确认金额
                let pri = "";
                for (let i in data){
                    pri += data[i].sum;
                    pri += "+"
                }
                pri = pri.substring(0, pri.length - 1);
                return eval(pri)
        },

        //查看
        handleClick(event){
            this.$router.push({ path: "/Car/CarDetail", query: { id: event._id } });
        },
        //确定绝当
        confirm(event){
        this.$confirm('确定要绝当吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").doc("${event}").update({data:{state:"绝当"}})`,
        }).then(res=>{
            if(res.data.errcode == 0){
                 this.$message({
                    type: 'success',
                    message: '绝当成功'
                });

                this.reload()
            }
        })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消绝当'
          });          
        });
        },

        //tab点击事件
        tabClick(e){
            if(e.index == 0){
                 this.reload()
                 this.tabIndex = e.index
            }else{
                this.title = "绝当业务"
                this.tabIndex = e.index
                this.axios
                .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query:
                    'db.collection("car_data").where({state:"绝当",reviewer:_.neq("")}).limit(1000).get()',
                }).then(res=>{
                      res.data.data.forEach((element, index, array) => {
                        array[index] = JSON.parse(element);
                    });
                    this.Total = res.data.pager.Total
                    this.tableData = res.data.data
                    this.zPri = this.sumPri(res.data.data)
                })
            }
        },

        //通过日期搜索
        SearchDate(){
            if(this.tabIndex == 0){
                return  this.$message.error('仅支持查询已绝当业务的数据哦,请切换到绝当业务在搜索');
            }
             this.axios
                .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query:
                    `db.collection("car_data").where({state:"绝当",reviewer:_.neq(""),DateClosed:_.eq("${this.searchDate}")}).limit(1000).get()`,
                }).then(res=>{
                    res.data.data.forEach((element,index,array)=>{
                        array[index] = JSON.parse(element)
                    })
                    if(res.data.data.length == 0){
                          this.$alert('该日期未查询到数据哦', '温馨提示', {
                            confirmButtonText: '确定',
                            });
                    }
                    this.tableData = res.data.data
                    console.log(res.data.data)
                })
        },
        //通过名字搜索
        SearchName(){
              if(this.tabIndex == 0){
                return  this.$message.error('仅支持查询已绝当业务的数据哦,请切换到绝当业务在搜索');
            }
                this.axios
                .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query:
                    `db.collection("car_data").where({state:"绝当",reviewer:_.neq(""),name:_.eq("${this.searchName}")}).limit(1000).get()`,
                }).then(res=>{
                    res.data.data.forEach((element,index,array)=>{
                        array[index] = JSON.parse(element)
                    })
                    this.tableData = res.data.data
                })

        }
    },

    created(){
        this.getTokens() //密钥

        //获取当前登录的用户数据
    this.getUserToken()

         //逾期、绝当鉴定日期
        this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
    },
    mounted() {
        setTimeout(()=>{
              this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("car_data").where({state:"在当",DateClosed:_.lt("' +
                this.day +
                '"),reviewer:_.neq("")}).limit(1000).get()',
            }).then(res=>{
               res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
                this.todayData = res.data;
                this.Total = res.data.pager.Total

               this.zPri = this.sumPri(res.data.data)

                //过滤今天绝当的数据
               let tData = res.data.data.filter(item=>{
                   return item.DateClosed ==  dayjs().subtract(6, "day").format("YYYY-MM-DD");
                })



                this.todayTotal = tData.length
                this.todayPri = this.sumPri(tData) || 0

            })

        },700)
    },
}
</script>

<style scoped>
    .content_head{
        display: flex;
        flex-direction: row;
        justify-content:space-between
    }
    .head_left{
        width: 58%;
        height: 180px;
       background-color: #ffffff;
       display: flex;
       flex-direction: row;
       justify-content:space-around;
       align-items: center;
    }
    /* .searchName{
        display: flex;
        flex-direction: row;
    } */
    .searchName input{
        height: 34px;
        border-color:#DCDFE6 ;
        border-radius: 5px;
       /* color: #DCDFE6; */
    }
    .head_right{
        width: 40%;
        height: 180px;
        background-color:  #ffffff;
        display: flex;
        flex-direction: row;
        justify-content:space-around;
        align-items: center;
    }
    .head_right_o{
        width: 40%;
        height: 120px;
        background-color: #59b0d3;
        border-radius: 12px;
       
    }
    .head_right_t{
        width: 40%;
        height: 120px;
        background-color: #59b0d3;
        border-radius: 12px;
    }
    .center{
         display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .head_text{
        font-size: 1.5em;
        color: #ffffff;
        font-weight: bold;
    }
    .middle{
        margin-top: 20px;
    }
  
</style>